module.exports = "data:image/webp;base64,UklGRigAAABXRUJQVlA4TBwAAAAvD8ADEA8wc3Mz9fMf8BDTENNcc58MEf0P+Sp5"